import { BlockWrapper } from '@smartfire/js-block-engine';
import style from './block.module.scss';

import { ReactComponent as Facebook } from '../assets/icons/facebook.svg';
import { ReactComponent as Linkedin } from '../assets/icons/linkedin.svg';
import { ReactComponent as Twitter } from '../assets/icons/twitter.svg';
import ButtonTag from '../components/button-tag/index';

function SingleArticle({ post }) {
    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.top}>
                <div className={style.tags}>
                    {post.tags && post.tags.map((tag, key) => <ButtonTag text={tag.name} key={key} />)}
                </div>
                <div className={style.socials}>
                    <a
                        href={'https://www.linkedin.com/cws/share?url=' + window.location.href}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Linkedin />
                    </a>
                    <a
                        href={'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Facebook />
                    </a>
                    <a
                        href={'https://twitter.com/intent/tweet?text=' + window.location.href}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Twitter />
                    </a>
                </div>
            </div>
            <h1 className={style.title}>{post.title}</h1>
            <div className={style.content}>
                <div className={style.decoration} />
                <p className={style.excerpt}>{post.excerpt}</p>
                <img src={post.thumbnail} alt={post.title} />
            </div>
        </BlockWrapper.Div>
    );
}

export default SingleArticle;
